import {StoredAuth} from 'r/utils/Stored';
import sleep from 'r/utils/sleep';
import showNotification from 'r/utils/showNotification';
import fetch from 'r/utils/fetch';

const GET = 'GET';
const PUT = 'PUT';
const POST = 'POST';
const DELETE = 'DELETE';

export const GET_ISSUER = 'GET_ISSUER';
export const GET_ISSUERS = 'GET_ISSUERS';
export const GET_AUTH = 'GET_AUTH';
export const GET_AUTH_CMS = 'GET_AUTH_CMS';
export const GET_AUTH_PLAY = 'GET_AUTH_PLAY';
export const POST_AUTH = 'POST_AUTH';
export const POST_AUTH_CMS = 'POST_AUTH_CMS';
export const POST_AUTH_PLAY = 'POST_AUTH_PLAY';
export const GET_ABI = 'GET_ABI';
export const GET_ANALYSES = 'GET_ANALYSES';
export const GET_ANALYSES_CMS = 'GET_ANALYSES_CMS';
export const GET_EVENTS_PLAY = 'GET_EVENTS_PLAY';
export const POST_ANALYSES = 'POST_ANALYSES';
export const POST_ANALYSES_CMS = 'POST_ANALYSES_CMS';
export const POST_ANALYSES_VERIFY = 'POST_ANALYSES_VERIFY';
export const POST_ANALYSES_VERIFY_CMS = 'POST_ANALYSES_VERIFY_CMS';
export const DELETE_ANALYSES = 'DELETE_ANALYSES';
export const DELETE_ANALYSES_CMS = 'DELETE_ANALYSES_CMS';
export const GET_TWEET = 'GET_TWEET';
export const GET_TWEET_CMS = 'GET_TWEET_CMS';
export const POST_TWEET = 'POST_TWEET';
export const POST_TWEET_CMS = 'POST_TWEET_CMS';
export const GET_PAIRS = 'GET_PAIRS';
export const GET_ISSUER_ACCOUNTS_COLLISIONS = 'GET_ISSUER_ACCOUNTS_COLLISIONS';
export const POST_RESOLVE_COLLISION = 'POST_RESOLVE_COLLISION';
export const PUT_ISSUER = 'PUT_ISSUER';
export const PUT_ADMIN_INFO = 'PUT_ADMIN_INFO';
export const POST_EMAIL = 'POST_EMAIL';
export const POST_EVENT_PLAY = 'POST_EVENT_PLAY';
export const PUT_EVENT_PLAY = 'PUT_EVENT_PLAY';
export const DELETE_EVENT_PLAY = 'DELETE_EVENT_PLAY';
export const GET_MARKETS_SCORE = 'GET_MARKETS_SCORE';
export const POST_MARKET_SCORE = 'POST_MARKET_SCORE';
export const PUT_MARKET_SCORE = 'PUT_MARKET_SCORE';
export const DELETE_MARKET_SCORE = 'DELETE_MARKET_SCORE';
export const PUT_ANALYSES = 'PUT_ANALYSES';
export const PUT_ANALYSES_CMS = 'PUT_ANALYSES_CMS';


const getFetch = (url, options, endpointId) => fetch(url, options)
  .then(async response => {
    let responseBody;
    try {
      responseBody = await response.json();
    }
    catch {}
    if (response.status === 401 && responseBody?.message === 'JWT_EXPIRED') {
      StoredAuth.set(null);
      showNotification('error', 'Session is expired. The page will be reloaded');
      await sleep(3_001);
      window.location.href = '/';
      await sleep(9_999_999);
    }
    if (options.signal?.aborted) {
      throw options.signal.reason;
    }
    if (response.ok) {
      return responseBody;
    }
    const error = new Error(`${endpointId}: ${response.status}`);
    error.name = 'fetchApi';
    console.error(JSON.stringify(responseBody)); // eslint-disable-line no-console
    console.error(JSON.stringify(options)); // eslint-disable-line no-console
    error.fromFetchApi = true;
    error.response = response;
    error.body = responseBody;
    error.extra = {
      responseBody,
      code: response.status,
      url,
      options,
    };
    throw error;
  })
;

let Queue = Promise.resolve();
const requests = [];
const withQueue = false;

async function queueAdd(url, options, endpointId) {
  if (withQueue) {
    if (!import.meta.env.IS_SERVER) {
      window.logRequests = () => { // eslint-disable-line no-restricted-syntax
        console.log([...requests].sort((a, b) => b[0] - a[0])); // eslint-disable-line no-console
      };
    }
    const patched = async () => {
      const before = Date.now();
      const result = await getFetch(url, options, endpointId);
      const after = Date.now();
      const diff = after - before;
      // console.log('Requsting...'); // eslint-disable-line no-console
      // console.log(url); // eslint-disable-line no-console
      // console.log(options); // eslint-disable-line no-console
      // console.log(`Done: ${Math.floor(diff / 10) / 100}s`); // eslint-disable-line no-console
      requests.push([Math.floor(diff / 10) / 100, url, options]);
      return result;
    };
    Queue = Queue.then(patched).catch(patched);
    return Queue;
  }
  else {
    return getFetch(url, options, endpointId);
  }
}


export function fetchApiRaw(endpointId, {signal, queryParams, urlParams, body} = {}, accessToken) {
  const [method, base] = (() => {
    switch (endpointId) {
      case POST_TWEET_CMS:
      case POST_TWEET: {
        return [
          POST,
          'tweet',
        ];
      }
      case GET_TWEET_CMS:
      case GET_TWEET: {
        return [
          GET,
          'tweet',
        ];
      }
      case POST_EMAIL: {
        return [
          POST,
          'subscription',
        ];
      }
      case POST_EVENT_PLAY: {
        return [
          POST,
          'event',
        ];
      }
      case GET_MARKETS_SCORE: {
        return [
          GET,
          'markets',
        ];
      }
      case POST_MARKET_SCORE: {
        return [
          POST,
          'markets',
        ];
      }
      case PUT_MARKET_SCORE: {
        const [id] = urlParams;
        return [
          PUT,
          `markets/${id}`,
        ];
      }
      case DELETE_MARKET_SCORE: {
        const [id] = urlParams;
        return [
          DELETE,
          `markets/${id}`,
        ];
      }
      case GET_ANALYSES_CMS:
      case GET_ANALYSES: {
        return [
          GET,
          'analyses',
        ];
      }
      case GET_EVENTS_PLAY: {
        return [
          GET,
          'events',
        ];
      }
      case GET_PAIRS: {
        return [
          GET,
          'pairs',
        ];
      }
      case POST_ANALYSES_CMS:
      case POST_ANALYSES: {
        return [
          POST,
          'analyses',
        ];
      }
      case POST_ANALYSES_VERIFY_CMS:
      case POST_ANALYSES_VERIFY: {
        return [
          POST,
          'analyses/verify',
        ];
      }
      case DELETE_ANALYSES_CMS:
      case DELETE_ANALYSES: {
        const [id] = urlParams;
        return [
          DELETE,
          `analyses/${id}`,
        ];
      }
      case DELETE_EVENT_PLAY: {
        const [id] = urlParams;
        return [
          DELETE,
          `event/${id}`,
        ];
      }
      case PUT_ANALYSES_CMS:
      case PUT_ANALYSES: {
        const [id] = urlParams;
        return [
          PUT,
          `analyses/${id}`,
        ];
      }
      case PUT_EVENT_PLAY: {
        const [id] = urlParams;
        return [
          PUT,
          `event/${id}`,
        ];
      }
      case GET_ISSUERS:
        return [
          GET,
          'issuers',
        ];
      case GET_ISSUER:
        return [
          GET,
          'issuer',
        ];
      case PUT_ISSUER:
        return [
          PUT,
          'issuer',
        ];
      case PUT_ADMIN_INFO:
        return [
          PUT,
          'issuer/adminInfo',
        ];
      case GET_AUTH_CMS:
      case GET_AUTH:
        return [
          GET,
          'auth',
        ];
      case GET_ISSUER_ACCOUNTS_COLLISIONS:
        return [
          GET,
          'issuerAccountsCollisions',
        ];
      case POST_AUTH_CMS:
      case POST_AUTH:
        return [
          POST,
          'auth',
        ];
      case POST_RESOLVE_COLLISION: {
        const [id] = urlParams;
        return [
          POST,
          `issuerAccountsCollisions/${id}/resolve`,
        ];
      }
      case GET_ABI: {
        const [address] = urlParams;
        return [
          GET,
          `abi/${address}`,
        ];
      }
      default:
        throw new Error(`INVALID ENDPOINT ${endpointId}`);
    }
  })();
  const headers = {};
  headers['Content-Type'] = 'application/json';
  if (accessToken) {
    headers.Authorization = `Bearer ${accessToken}`;
  }
  let url = `${getBaseUrl(endpointId)}/${base}`;
  if (queryParams) {
    url += `?${Object.entries(queryParams).map(([key, value]) => `${key}=${value}`).join('&')}`;
  }
  const options = {method, headers, signal};
  if (body) {
    if ([].includes(endpointId)) {
      options.body = body;
    }
    else {
      options.body = JSON.stringify(body);
    }
  }
  return queueAdd(url, options, endpointId);
}

function getBaseUrl(endpointId) {
  if (endpointId.includes('_CMS')) {
    return import.meta.env.VITE_BACKEND_CMS_URL_API;
  }
  else if (endpointId.includes('_PLAY')) {
    return import.meta.env.VITE_BACKEND_PLAY_URL_API;
  }
  else if (endpointId.includes('_SCORE')) {
    return import.meta.env.VITE_BACKEND_SCORE_URL_API;
  }
  else {
    return import.meta.env.VITE_BACKEND_URL_API;

  }
}

